import { SiteItemData, SiteVideoData } from "../../../../interfaces";
import { enablePageRefresh, disablePageRefresh } from "../../../../siteWidgets/siteWidgetUtils";
import { categoryObj } from "./NewYnetTvVerticalDynamicMutamComponenta";
import { NewYnetTvVerticalDynamicMutamItem } from "./NewYnetTvVerticalDynamicMutamItem";
import { PromoCarouselLtr } from "../../../newYnetLTRTvVerticalDynamic/components/promoCarouselLtr";
import { VerticalVideoOverlayPlayer } from "../../../verticalVideoOverlayPlayer/verticalVideoOverlayPlayer";
import { PromoCarousel } from "./promoCarousel";
 
interface NewYnetTvVerticalDynamicMutamProps {
    videoList: SiteItemData[]
    isTabVisible: boolean
    isTitleVisible: boolean
    isSubTitleVisible: boolean
    tabTitleText: string
    repeatAds: number
    maxAds: number
    firstAdPlace: number
    shouldDisplayMobileAds: boolean
    category: categoryObj
    domain: string
    showPrerollAds: boolean
    tabBackgroundColor: string
    twitterLink: string
    youtubeLink: string
    tiktokLink: string
    facebookLink: string
    whatsappLink: string
    instagramLink: string
    displayType: string
    isLTR: boolean
    languageCode: string
}
 
interface NewYnetTvVerticalDynamicMutamState {
    isOverlayOpen: boolean
    selectedVideo: number
    togglePromoActive: boolean
    currentPromoIndex: number
    promoViewportWidth: number
    isPromoCarouselInView: boolean
    disableAutoScrollIntoView: boolean
}
 
export class NewYnetTvVerticalDynamicMutam extends React.Component<NewYnetTvVerticalDynamicMutamProps, NewYnetTvVerticalDynamicMutamState> {
    constructor(props) {
        super(props);
        this.state = {
            selectedVideo: -1,
            isOverlayOpen: false,
            togglePromoActive: false,
            currentPromoIndex: 0,
            promoViewportWidth: 375,
            isPromoCarouselInView: false,
            disableAutoScrollIntoView: false,
        }
    }
  private scrollPosition: number = 0;
    private videoGalleryRef;
    private intersectionObserver: IntersectionObserver;
 
    componentDidMount() {
        this.setState({ promoViewportWidth: window.innerWidth });
 
        this.intersectionObserver = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    this.setState({ isPromoCarouselInView: true });
                } else {
                    this.setState({ isPromoCarouselInView: false });
                }
            },
            { threshold: 0.5 }
        );
 
        if (this.videoGalleryRef) {
            this.intersectionObserver.observe(this.videoGalleryRef);
        }
    }
 
    componentWillUnmount() {
        if (this.intersectionObserver && this.videoGalleryRef) {
            this.intersectionObserver.disconnect();
        }
               if (this.state.isOverlayOpen) {
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            // Restore scroll position
            window.scrollTo(0, this.scrollPosition);
        }
    }
 
    private onOpenVideoGalleryView = (originalVideoListIndex: number) => {
        const { videoList } = this.props;
        const initialFeedSlide = this.getListWithAds().findIndex((element) => element.itemId === videoList[originalVideoListIndex].itemId);
        this.setState({ selectedVideo: initialFeedSlide, currentPromoIndex: 0, isPromoCarouselInView: false }, () => { this.setState({ isOverlayOpen: true }) });
        disablePageRefresh();
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            document.body.style.overflow = "hidden";
            document.body.style.position = "fixed";
            document.body.style.top = `-${this.scrollPosition}px`;
            document.body.style.width = "100%";
    }
 
    private onCloseVideoGalleryView = () => {
        this.setState({ isOverlayOpen: false, isPromoCarouselInView: true, selectedVideo: -1 });
        enablePageRefresh();
          document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            window.scrollTo(0, this.scrollPosition);
    }
 
    private onVideoEnded = () => {
        this.setState((prevState) => {
            const { videoList } = this.props;
            const nextPromoIndex = prevState.currentPromoIndex + 1;
 
            if (nextPromoIndex < videoList.length) {
                let nextPromoIndexToCheck = nextPromoIndex;
 
                while (nextPromoIndexToCheck < videoList.length) {
                    if ((videoList[nextPromoIndexToCheck].media as SiteVideoData).promoPath) {
                        return { currentPromoIndex: nextPromoIndexToCheck };
                    }
                    nextPromoIndexToCheck++;
                }
            } else {
                return { currentPromoIndex: -1 }; // once all promos are played, stop the auto playing carousel
            }
        });
    }

    private onUserArrowInteraction = () => {
        if (!this.state.disableAutoScrollIntoView) {
            this.setState({ disableAutoScrollIntoView: true });
        }
    }
 
    private pushGA4Event = (action: string, isOverlayOpen: boolean) => {
        if (typeof window == "undefined" || !window.dataLayer) return;
        const { category } = this.props;
        const actionPrefix = category && category.name ? (category.name === "דף הבית") ? "homepage" : category.name : "homepage";
        const gaAction = isOverlayOpen ? `video_${action}` : `${actionPrefix}_${action}`;
 
        window.dataLayer.push({
            event: "content_click",
            vertical_video_action: gaAction,
        });
    };
 
    private getListWithAds = () => {
        const { repeatAds, maxAds, firstAdPlace, videoList, shouldDisplayMobileAds, showPrerollAds } = this.props;
        const videoListCopy = [...videoList];
        const videoListLength = videoListCopy.length;
        let numberOfAds = firstAdPlace > videoListLength ? 0 : Math.min(maxAds, videoListLength - firstAdPlace, Math.floor((videoListLength - firstAdPlace) / repeatAds + 1));
        const newListLength = videoListLength + numberOfAds;
        const baseId = "ads.vertical.native.";
        let newList = [];
        let adCount = 1;
 
        if (showPrerollAds) return this.getListWithPreRollsAds();
        if (maxAds === 0 || !shouldDisplayMobileAds) return videoListCopy;
 
        for (let i = 0; i < newListLength; i++) {
            if (i < firstAdPlace) {
                newList.push(videoListCopy.shift());
            } else if (i === firstAdPlace && numberOfAds > 0) {
                newList.push(`${baseId}${adCount}`);
                numberOfAds--;
                adCount++;
            } else if (numberOfAds > 0 && (i - firstAdPlace) % (repeatAds + 1) === 0) {
                newList.push(`${baseId}${adCount}`);
                numberOfAds--;
                adCount++;
            } else {
                newList.push(videoListCopy.shift());
            }
        }
        return newList;
    }
 
    private getListWithPreRollsAds = () => {
        const { repeatAds, maxAds, firstAdPlace, videoList, showPrerollAds } = this.props;
        const videoListCopy = [...videoList];
        const videoListLength = videoListCopy.length;
        let numberOfAdsLeft = firstAdPlace > videoListLength ? 0 : Math.min(maxAds, videoListLength - firstAdPlace, Math.floor((videoListLength - firstAdPlace) / repeatAds + 1));
        const totalAdsNumber = firstAdPlace > videoListLength ? 0 : Math.min(maxAds, videoListLength - firstAdPlace, Math.floor((videoListLength - firstAdPlace) / repeatAds + 1));
 
        if (maxAds === 0) return videoListCopy;
        let newList = [];
 
        for (let i = 0; i < videoList.length; i++) {
            let prerollIndex = Math.abs(numberOfAdsLeft - (totalAdsNumber + 1));
            if (i + 1 < firstAdPlace) {
                newList.push({ ...videoList[i], hidePrerollAds: true, prerollIndex: undefined });
            } else if (i === firstAdPlace && numberOfAdsLeft > 0) {
                newList.push({ ...videoList[i], hidePrerollAds: false, prerollIndex: showPrerollAds ? prerollIndex : undefined });
                numberOfAdsLeft--;
            } else if (numberOfAdsLeft > 0 && (i - firstAdPlace) % (repeatAds + 1) === 0) {
                newList.push({ ...videoList[i], hidePrerollAds: false, prerollIndex: showPrerollAds ? prerollIndex : undefined });
                numberOfAdsLeft--;
            } else {
                newList.push({ ...videoList[i], hidePrerollAds: true, prerollIndex: undefined });
            }
        }
 
        return newList;
    }
 
    public render() {
        const { videoList, isTabVisible, isTitleVisible, isSubTitleVisible, tabTitleText, domain, showPrerollAds, tabBackgroundColor, twitterLink, youtubeLink, tiktokLink, facebookLink, whatsappLink, instagramLink, displayType, isLTR, languageCode, category } = this.props;
        const { isOverlayOpen, selectedVideo, togglePromoActive, currentPromoIndex, promoViewportWidth, isPromoCarouselInView, disableAutoScrollIntoView } = this.state;
        const basePromoWidthFit375 = displayType === "basic" ? 150 : (displayType === "medium" ? 192 : 248);
        const promoWidth = (promoViewportWidth / 375) * basePromoWidthFit375;
        const PromoCarouselComponent = isLTR ? PromoCarouselLtr : PromoCarousel;
 
        return (
            <div className="videoGalleryVerticalMutamWrapper" ref={(ref) => { this.videoGalleryRef = ref; }}>
                {isTabVisible &&
                    <div className="videoGalleryVerticalTab componentaTab" style={{ backgroundColor: tabBackgroundColor }}>
                        <span>{tabTitleText}</span>
                        <div className="mediaLinks">
                            {youtubeLink && <a className="youtubeLink" href={youtubeLink} target="blank"></a>}
                            {twitterLink && <a className="twitterLink" href={twitterLink} target="blank"></a>}
                            {whatsappLink && <a className="whatsappLink" href={whatsappLink} target="blank"></a>}
                            {tiktokLink && <a className="tiktokLink" href={tiktokLink} target="blank"></a>}
                            {instagramLink && <a className="instagramLink" href={instagramLink} target="blank"></a>}
                            {facebookLink && <a className="facebookLink" href={facebookLink} target="blank"></a>}
                        </div>
                    </div>
                }
 
                <PromoCarouselComponent
                    marginRight={0}
                    imageWidth={promoWidth}
                    pushGA4Event={this.pushGA4Event}
                    itemListLength={videoList.length}
                    currentPromoIndex={currentPromoIndex}
                    onUserArrowInteraction={this.onUserArrowInteraction}
                >
                    {videoList.map((videoItem, index) =>
                        <NewYnetTvVerticalDynamicMutamItem
                            videoIndex={index}
                            videoItem={videoItem}
                            key={videoItem.itemId}
                            onVideoEnded={this.onVideoEnded}
                            pushGA4Event={this.pushGA4Event}
                            currentPromoIndex={currentPromoIndex}
                            isPromoCarouselInView={isPromoCarouselInView}
                            onOpenVideoGalleryView={this.onOpenVideoGalleryView}
                            disableAutoScrollIntoView={disableAutoScrollIntoView}
                        />
                    )}
                </PromoCarouselComponent >
 
                <VerticalVideoOverlayPlayer
                    isLTR={isLTR}
                    domain={domain}
                    isMobile={true}
                    category={category}
                    languageCode={languageCode}
                    isOverlayOpen={isOverlayOpen}
                    showPrerollAds={showPrerollAds}
                    isTitleVisible={isTitleVisible}
                    videoItems={this.getListWithAds()}
                    selectedVideoIndex={selectedVideo}
                    isSubTitleVisible={isSubTitleVisible}
                    onVideoOverlayClose={this.onCloseVideoGalleryView}
                />
            </div>
        )
    }
}
 
 